import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { LayoutModule } from '../shared/layout/layout.module';
import { TranslateModule } from '@ngx-translate/core';
import { PricingComponent } from './pricing.component';
import { pricingRoutes } from './pricing.routes';

@NgModule({
  imports: [SharedModule, LayoutModule, RouterModule.forChild(pricingRoutes), TranslateModule],
  declarations: [PricingComponent],
  exports: [],
  entryComponents: [PricingComponent]
})
export class PricingModule {}
